import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Cushion, Rectangle, Shadow, Space, Typography } from '@pitchero/react-ui';

const EventAttendeeList = ({ attendees }) => {
  if (isEmpty(attendees)) {
    return null;
  }

  return (
    <Space bottom="xlarge">
      <Shadow>
        <Rectangle fill="white" radius="rounded">
          <Cushion all="large">
            <Cushion>
              <Typography preset="tag--large" color="dustygrey" component="div">
                {`${attendees.length} members attending`}
              </Typography>
            </Cushion>
          </Cushion>
        </Rectangle>
      </Shadow>
    </Space>
  );
};

EventAttendeeList.propTypes = {
  attendees: PropTypes.arrayOf(
    PropTypes.shape({
      avatar: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
};

export default EventAttendeeList;
